import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ParallaxService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getTitle = (): string => 'Parallax';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'parallax/0', 'title': 'Followers', 'theme': 'layout1' },
      { 'url': 'parallax/1', 'title': 'Engine & performance', 'theme': 'layout2' },
      { 'url': 'parallax/2', 'title': 'Reviews', 'theme': 'layout3' },
      { 'url': 'parallax/3', 'title': 'News', 'theme': 'layout4' }
    ];
  }

  getDataForTheme = (menuItem: any): any => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'Followers',
      'headerImage': 'assets/imgs/background/7.jpg',
      'title': 'News in the auto industry',
      'iconLike': 'icon-thumb-up',
      'iconFavorite': 'icon-heart',
      'iconShare': 'icon-share-variant',
      'titleFolowers': 'Folowers',
      'items': [
        {
          'id': 1,
          'title': 'Sara J. Rogers',
          'subTitle': 'sara@.com',
          'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/avatar/17.jpg',
          'imageAlt': 'avatar',
          'button': 'Read more',
          'icon': 'chevron-down',
        },
        {
          'id': 2,
          'title': 'Dana Robinson',
          'subTitle': 'robinson@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/18.jpg',
          'imageAlt': 'avatar',
          'button': 'Read more',
          'icon': 'chevron-down',
        },
        {
          'id': 3,
          'title': 'Dennis K. Godina',
          'subTitle': 'dodina@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/19.jpg',
          'imageAlt': 'avatar',
          'button': 'Read more',
          'icon': 'chevron-down',
        },
        {
          'id': 4,
          'title': 'Robert  Willer',
          'subTitle': 'willer@.com',
          'description': 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteratione',
          'image': 'assets/imgs/avatar/20.jpg',
          'imageAlt': 'avatar',
          'button': 'Read more',
          'icon': 'chevron-down',
        },
        {
          'id': 5,
          'title': 'Boring Dreams',
          'subTitle': 'boring@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/21.jpg',
          'imageAlt': 'avatar',
          'button': 'Read more',
          'icon': 'chevron-down',
        },
        {
          'id': 6,
          'title': 'Elizabeth B. Custer',
          'subTitle': 'custer@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/22.jpg',
          'imageAlt': 'avatar',
          'button': 'Read more',
          'icon': 'chevron-down',
        },
        {
          'id': 7,
          'title': 'Jean S. Beaty',
          'subTitle': 'jean@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/23.jpg',
          'imageAlt': 'avatar',
          'button': 'Read more',
          'icon': 'chevron-down',
        },
        {
          'id': 8,
          'title': 'Sara Black',
          'subTitle': 'black@.us',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/24.jpg',
          'imageAlt': 'avatar',
          'button': 'Read more',
          'icon': 'chevron-down',
        },
        {
          'id': 9,
          'title': 'Justin Cain',
          'subTitle': 'cain@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/19.jpg',
          'imageAlt': 'avatar',
          'button': 'Read more',
          'icon': 'chevron-down',
        },
        {
          'id': 10,
          'title': 'Kenneth Jones',
          'subTitle': 'jones@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/20.jpg',
          'imageAlt': 'avatar',
          'button': 'Read more',
          'icon': 'chevron-down',
        }
      ]
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Engine & performance',
      'headerImage': 'assets/imgs/background/5.jpg',
      'title': 'ENGINE & PERFORMANCE',
      'items': [
        {
          'id': 1,
          'title': 'News cars',
          'seeAll': 'See All',
          'items': [
            {
              'id': 1,
              'title': 'Toyota Supra',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/1.jpg',
            },
            {
              'id': 2,
              'title': 'BMW M4 CS',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/2.jpg',
            },
            {
              'id': 3,
              'title': 'Ford Mustang',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/3.jpg',
            },
            {
              'id': 4,
              'title': 'BMW M2 CS',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/4.jpg',
            }
          ]
        },
        {
          'id': 2,
          'title': 'Best cars',
          'seeAll': 'See All',
          'items': [
            {
              'id': 1,
              'title': 'Audi RS5',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/5.jpg',
            },
            {
              'id': 2,
              'title': 'Chevrolet Camaro',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/6.jpg',
            },
            {
              'id': 3,
              'title': 'Audi RS6 Avant',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/7.jpg',
            },
            {
              'id': 4,
              'title': 'BMW M5',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/4.jpg',
            }
          ]
        },
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Reviews',
      'bigTitle': 'Ferrari 348 GT Competizione',
      'title': 'Reviews',
      'subtitle': 'Similar Lists',
      'seeAll': 'See All',
      'icon': 'arrow-forward',
      'headerImage': 'assets/imgs/background/6.jpg',
      'avatar': 'assets/imgs/avatar/23.jpg',
      'avatarTitle': 'Jason Graham',
      'avatarSubitle': 'Latest Tenant',
      'description': 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.',
      'items': [
        {
          'id': 1,
          'title': 'Ferrari Challenge Stradale',
          'subtitle': '2 in stock',
          'price': '$ 10000 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/3.jpg',
        },
        {
          'id': 2,
          'title': 'Ferrari F430 Scuderia',
          'subtitle': '2 in stock',
          'price': '$ 10000 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 3,
          'title': 'Ferrari F430 Spider',
          'subtitle': '2 in stock',
          'price': '$ 10000 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'title': 'Ferrari 458 Speciale',
          'subtitle': '2 in stock',
          'price': '$ 10000 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'title': 'Ferrari 458 Speciale',
          'subtitle': '2 in stock',
          'price': '$ 10000 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/7.jpg',
        },
      ]
    };
  }

  //* Data Set for page 4
  getDataForLayout4 = (): any => {
    return {
      'toolbarTitle': 'News',
      'headerImage': 'assets/imgs/background/3.jpg',
      'title': 'The Greatest V8 Ferraris Ever',
      'price': '$ 10000',
      'priceTitle': 'per month',
      'iconsStarsTitle': '8 km to the center',
      'button': 'Buy Now',
      'descriptionTitle': 'Description',
      'description1': `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
             ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.`,
      'description2': `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
             ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.`,
      'description3': `It is a long established fact that a reader will be distracted by the readable
             content of a page when looking at its layout. The point of using Lorem Ipsum is that it has
              a more-or-less normal distribution of letters, as opposed to using Content here, content here,
               making it look like readable English`,
      'description4': `Contrary to popular belief, Lorem Ipsum is not simply random text.
             It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.
              Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia,
               looked up one of the more obscure Latin words, consectetur,
             from a Lorem Ipsum passage, and going through the cites of the word
              in classical literature, discovered the undoubtable source.`,
      "iconsStars": [
        {
          "icon": "star",
        },
        {
          "icon": "star"
        },
        {
          "icon": "star"
        },
        {
          "icon": "star"
        },
        {
          "icon": "star-outline"
        }
      ],
    };
  }

  load(item: any): Observable<any> {
    this.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('parallax/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            this.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            this.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        this.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
